/**
 * What a proposal page says when someone edits a fee schedule whose rates are masked from them (#6614).
 *
 * The page cannot merge categories into rates it cannot read, so it stops before the edit. These
 * sentences name what is in the way and who can do it instead. They replaced "Cannot add categories
 * because the current fee schedule is masked", which named an internal state and nothing to do.
 */
export const HIDDEN_RATES_ADD_MESSAGE =
  "You can't add categories to this fee schedule because its rates are hidden from you. Ask someone who can see the rates to add them.";

export const HIDDEN_RATES_UPDATE_MESSAGE =
  "You can't change this category because the fee schedule's rates are hidden from you. Ask someone who can see the rates to change it.";
